import objectivec from "refractor/objectivec";
export default objectivec;